(function () {
    "use strict";

    /**
     * A custom attribute which handles required confirmation checkboxes.
     * This allows supporting explicit confirmation before an action becomes possible.
     * Similar to confirming you have read the terms and conditions.
     */
    angular.module("app").directive("confirmationCheckRequired", ConfirmationCheckRequiredAttribute);

    function ConfirmationCheckRequiredAttribute() {
        return {
            require: "ngModel",
            restrict: "A",
            link: function (_scope, _element, _attrs, ngModelController) {
                ngModelController.$validators.checkRequired = function (modelValue, viewValue) {
                    const value = modelValue || viewValue;
                    return value === true;
                };
            }
        };
    }
})();
